<template>
  <div class="analysis">
    <div class="analysis-overview">
    <div class="analysis-head">
      <div class="analysis-head__num">01</div>
      <div class="analysis-head__title">{{title}}概览</div>
    </div>
    <div class="p-select">
      <i class="el-icon-date"></i>
        <el-select popper-class="selectFrom" v-model="value" placeholder="" @change="timeChange">
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
            >
          </el-option>
        </el-select>
    </div>
    </div>
    <div class="analysis-detail">
      <div class="analysis-list">
        <div class="analysis-item">
          <img src="../../images/test_num.png" alt="">
          <span>{{itemOne}}</span>
          <span class="mr-20">52<span class="fz-24">个</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/class_study_day.png" alt="">
          <span>{{itemTwo}}</span>
          <span class="mr-20">52<span class="fz-24">%</span></span>
        </div>
        <div class="analysis-item">
          <img src="../../images/avg_lv.png" alt="">
          <span>{{itemThree}}</span>
          <span class="mr-20">52<span class="fz-24">%</span></span>
        </div>
      </div>
      <div class="subject-distribute ">
      <span class="title">{{itemFour}}</span>
      <div class="subject-charts">
        <div class="subject-bg">
          <p class="test-num">总测评次数</p>
          <p class="test-total">{{total}}<span>次</span> </p>
          <div class="subject"></div>
        </div>
      </div>
      </div>
    </div>
    <test-line />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import TestLine from './test-line.vue';

export default {
  name: 'AnalysisOverview',
  components: {
    TestLine,
  },
  props: {
    title: {
      default: '测评',
      type: String,
    },
    itemOne: {
      default: '布置测评数',
      type: String,
    },
    itemTwo: {
      default: '平均完成率',
      type: String,
    },
    itemThree: {
      default: '平均正答率',
      type: String,
    },
    itemFour: {
      default: '测评学科分布',
      type: String,
    },
    total: {
      default: 44,
    },
  },
  data() {
    return {
      value: '',
      options: [],
      colorOne: '',
      colorTwo: '',
      totalNum: 0, // 总测评次数
      index: 0, // 下标
      subjectList: [
        {
          subject_id: 1,
          subject_name: '语文',
          student_num: 22,
        },
        {
          subject_id: 2,
          subject_name: '数学',
          student_num: 22,
        },

      ],
    };
  },
  mounted() {
    this.options = this.getMonth();
    this.initCharts();
  },
  computed: {
    arrList() {
      const arr = [];
      this.subjectList.forEach((item) => {
        if (item.subject_id === 2) {
          this.colorOne = '#60DBA4';
          this.colorTwo = '#3BDE93';
        } else if (item.subject_id === 4) {
          this.colorOne = '#93ECFF';
          this.colorTwo = '#28D5EE';
        } else if (item.subject_id === 1) {
          this.colorOne = '#FFE393';
          this.colorTwo = '#FFBD87';
        } else if (item.subject_id === 3) {
          this.colorOne = '#FDA76F';
          this.colorTwo = '#FA6E3C';
        } else if (item.subject_id === 5) {
          this.colorOne = '#B993FF';
          this.colorTwo = '#A9B6FF';
        } else {
          this.colorOne = '#00F1FF';
          this.colorTwo = '#8A4FFF';
        }
        arr.push({
          value: item.student_num,
          name: item.subject_name,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: this.colorOne,
              }, {
                offset: 1,
                color: this.colorTwo,
              }]),
            },
          },
        });
      });
      return arr;
    },
  },
  methods: {
    timeChange() {
      console.log('change');
    },
    getMonth() { // 获取时间列表
      let getmoth = dayjs(new Date()).add(1, 'month');
      if (getmoth.$M === 0) {
        this.value = `${getmoth.$y - 1}-${12}`;
        getmoth = dayjs(`${getmoth.$y - 1}-${11}`).add(1, 'month');
        const list = [];
        for (let i = 1; i <= getmoth.$M + 1; i += 1) {
          list.push({
            value: `${getmoth.$y}-${i}`,
            label: `${getmoth.$y}-${i}`,
          });
        }
        return list;
      }
      this.value = `${getmoth.$y}-${getmoth.$M}`;
      const list = [];
      for (let i = 1; i <= getmoth.$M; i += 1) {
        list.push({
          value: `${getmoth.$y}-${i}`,
          label: `${getmoth.$y}-${i}`,
        });
      }
      console.log(list, 'lost');
      return list;
    },
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.subject'));
      // 绘制图表
      const that = this;
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        legend: {
          x: '20%',
          y: '80%',
          // orient: 'vertical',
          icon: 'circle',
          textStyle: {
            color: '#303133',
            fontSize: 14,
          },
          formatter(val) {
            console.log(val);
            console.log(that.arrList);
            const { arrList } = that;
            that.totalNum = 0;
            arrList.forEach((v, i) => {
              that.totalNum += v.value;
              if (v.name === val) {
                that.index = i;
              }
            });
            return `${val} | ${arrList[that.index].value}个  ${((arrList[that.index].value / that.totalNum) * 100).toFixed(0)}%`;
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['32%', '42%'],
            center: ['50%', '50%'],
            labelLine: {
              length: 25,
              length2: 40,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // console.log(params, 'params');
                  // 自定义颜色
                  const res = `{value|${params.percent}%}`;
                  return res;
                },
                rich: {
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 14,
                    color: '#303133',
                  },
                },
              },
            },
            data: this.arrList,
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis{
  background: #fff;
  padding: 41px 60px 0 31px;
  .analysis-overview{
  display: flex;
  justify-content: space-between;
  .analysis-head{
  display: flex;
  align-items: center;
  margin-bottom:11px ;
  &__num{
    font-size: 22px;

    font-weight: bold;
    color: rgba(0, 0, 0, 0.8);
    margin-right: 14px;
    background:url('~@/views/pt/images/class_bg.png');
    background-size:cover;
    width:38px;
    height:29px;
    text-align: center;
  }
  &__title{
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
  }
  }
  .p-select{
    position: relative;
    /deep/ {
      .el-icon-date{
        position: absolute;
        z-index: 999;
        top: 12px;
        left: 14px;
      }
    }
  }
  /deep/ {
    .el-select {
      width: 184px;
      height: 40px;
      .el-input__inner{
        padding-left: 35px;
        color: #1890FF;
      }
    }
  }
 }
  .analysis-detail{
   margin-top: 40px;
   display: flex;
   .analysis-list{
     .analysis-item{
       margin-bottom: 32px;
      width: 350px;
      height: 110px;
      background: #F0F2F8;
      border-radius: 12px;
      display: flex;
      padding-left: 21px;
      align-items: center;
      img{
        width: 72px;
        height: 72px;
        margin-right:24px ;
      }
      span{
        font-weight: 500;
        color: #808BAA;
        font-size: 18px;
      }
      .mr-20{
        margin-left: 20px;
        color:#1989FA;
        font-size: 32px;
      }
      .fz-24{
        font-size: 24px;
        margin-left: 10px;

      }
     }
   }
   .subject-distribute{
     width: 500px;
     height: 500px;
     position: relative;
     margin-left: 50px;
   .title{
     position: absolute;
     top: 2%;
     left: 40%;
     transform: translate(-50%,-50%);
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
        left: 0;
        bottom: 3px;
      }
   }
   .subject-charts{
     position: absolute;
     top: 40%;
     left: 50%;
     transform: translate(-50%,-50%);
     .subject-bg{
        width: 248px;
        height: 248px;
        border-radius:50% ;
        background:#F1F7FF;
        position: relative;
        .subject{
          width: 500px;
          height: 500px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          z-index: 999;
        }
        .test-num{
          position: absolute;
          top: 43%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
        }
        .test-total{
          position: absolute;
          top: 60%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
          span{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.6);
          }
        }
     }
   }
  }
 }
}

</style>
